import URLConfig from '@Config/urls/url.config';
import { LinkItemProps } from '@Layouts/sidebar/AppSidebar';

const URL = URLConfig.CARD_MANAGEMENT_SYSTEM.DEBIT.DEBIT_OPERATIONS_MENU;

const DebitOperationsMenuLink: Array<LinkItemProps> = [
  {
    name: 'Ajout Nouveau Compte',
    link: URL.ADD_NEW_ACCOUNT,
    level: 3,
  },
  {
    name: 'Lien Compte Carte',
    link: URL.CARD_ACCOUNT_LINK,
    level: 3,
  },
  {
    name: 'Lien Compte trnfr Carte',
    link: URL.TRNFR_CARD_ACCOUNT_LINK,
    level: 3,
  },
  {
    name: 'Liste des Comptes',
    link: URL.ACCOUNT_LIST,
    level: 3,
  },
  {
    name: 'Liste des Comptes Transfert',
    link: URL.TRANSFER_ACCOUNT_LIST,
    level: 3,
  },
    
];

export default DebitOperationsMenuLink;
